import { useState, useEffect, useRef } from "react";

import Dropdown from "./Dropdown";
import { Link } from "react-router-dom";
import i18n from "i18next";

const MenuItems = ({ items, depthLevel }) => {
  const [dropdown, setDropdown] = useState(false);

  let ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    window.innerWidth > 960 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 960 && setDropdown(false);
  };

  return (
    <li
      className="menu-items"
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown((prev) => !prev)}
            style={{
              fontFamily:
                i18n.language.includes("en") ? "CI-Font-Title" : "CI-Font-Title-ar",
              textAlign: i18n.language.includes("en") ? "left" : "right",
            }}
          >
            {items.title}{" "}
            {depthLevel > 0 ? <span>&raquo;</span> : <span className="arrow" />}
          </button>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            style={{
              fontFamily:
                i18n.language.includes("en") ? "CI-Font-Title" : "CI-Font-Title-ar",
              textAlign: i18n.language.includes("en") ? "left" : "right",
            }}
          />
        </>
      ) : (
        <a
          style={{
            fontFamily:
              i18n.language.includes("en") ? "CI-Font-Title" : "CI-Font-Title-ar",
            textAlign: i18n.language.includes("en") ? "left" : "right",
          }}
          href={items.target}
        >
          {items.title}
        </a>
      )}
    </li>
  );
};

export default MenuItems;
